import { ETechnologiesLabels, ETechnologiesValues } from '@enums/common';

export const ALL_TECHNOLOGIES_QUANTITY = 3;
export const addTooltipText = 'Add cell';

export const technologyButtons = [
	{
		label: ETechnologiesLabels.T_4G_FDD,
		value: ETechnologiesValues.T_4G_FDD,
	},
	{
		label: ETechnologiesLabels.T_4G_TDD,
		value: ETechnologiesValues.T_4G_TDD,
	},
	{
		label: ETechnologiesLabels.T_5G,
		value: ETechnologiesValues.T_5G,
	},
];

export const technologyTabs = [
	{
		title: ETechnologiesLabels.T_4G_TDD,
		value: ETechnologiesValues.T_4G_TDD,
		isVisible: true,
	},
	{
		title: ETechnologiesLabels.T_4G_FDD,
		value: ETechnologiesValues.T_4G_FDD,
		isVisible: true,
	},
	{
		title: ETechnologiesLabels.T_5G,
		value: ETechnologiesValues.T_5G,
		isVisible: true,
	},
];

export const technologyTabsConfigLimenet = [
	{
		title: ETechnologiesLabels.C_4G_TDD,
		value: ETechnologiesValues.C_4G_TDD,
	},
	{
		title: ETechnologiesLabels.C_4G_FDD,
		value: ETechnologiesValues.C_4G_FDD,
	},
	{
		title: ETechnologiesLabels.C_5G,
		value: ETechnologiesValues.C_5G,
	},
];

export const crowdCellModalUnlinkConfirm = {
	question: 'Are you sure you want to unlink the site from the CrowCell?',
	children: 'Unlinking will clear all data. Please confirm your action.',
};
